import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Sicherheitshinweis für Entwickler
if (process.env.NODE_ENV === 'development') {
  console.warn(
    '🔒 SICHERHEITSHINWEIS: Azure Storage URLs mit Tokens sind in Browser DevTools (Network Tab) sichtbar.\n' +
    'Das ist normal in der Entwicklung, aber achte darauf, keine Screenshots der DevTools zu teilen!\n' +
    'In der Produktion haben Benutzer keinen DevTools-Zugriff.'
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
